import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Contact form submitted:', formData);
    alert('Thank you for contacting us! We will respond as soon as possible.');
  };

  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="back-link">← Back to Home</Link>
          <h1>Contact Us</h1>
          <p className="last-updated">We're here to help</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>Get In Touch</h2>
            <p>Have questions, concerns, or feedback? We'd love to hear from you.</p>
          </section>

          <section>
            <h2>Contact Information</h2>
            <div className="contact-info">
              <p><strong>Email:</strong> sahayak.platform@gmail.com</p>
            </div>
          </section>

          <section>
            <h2>Contact Form</h2>
            <div className="contact-form-container">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="category">Category *</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Category</option>
                    <option value="booking">Booking Assistance</option>
                    <option value="payment">Payment & Billing</option>
                    <option value="service-quality">Service Quality</option>
                    <option value="technical">Technical Issues</option>
                    <option value="safety">Safety Concerns</option>
                    <option value="helper">Helper Related</option>
                    <option value="business">Business Inquiry</option>
                    <option value="feedback">Feedback & Suggestions</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    placeholder="Brief description of your query"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="6"
                    placeholder="Please provide detailed information about your query or concern..."
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactUs; 